import FormLeftContent from "../../../../src/pages/pricing/form-left-content.md";
import FormRightContent from "../../../../src/pages/pricing/form-right-content.md";
import * as React from 'react';
export default {
  FormLeftContent,
  FormRightContent,
  React
};